import Service				from "./../../Libs/Service";

let Template = new Service({

	Name: "Template",

	Events: {

	},

	Actions: {

	},

	init() {

	}

});

//Делаем объект синглтоном чтобы при импортах возвращался тот же самый экземпляр
if (window.Template) Template = window.Template;
else window.Template = Template;

export { Template }

